<script>
import stripURLParams from "@/http/stripURLParams";

export default {
  name: "palettes",
  computed: {
    activeComponent() {
      if (this.isApparel) {
        return this.$store.state.standardNavigation.activeSubComponent !== '' ?
        `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`:
          this.$store.state.standardNavigation.activeComponent;
      } else {
        return this.$store.state.legacyNavigation.activeComponent;
      }
    },
    getPalettes() {
      return this.$store.state.swatches.palettes;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    swatchesByComponent() {
      return this.$store.state.swatches.swatchesByComponent;
    },
  },
  methods: {
    /**
     * @function loadPalettes
     * Adds the palettes that weren't download in preloader component(check out created method).
     * If the pdm has ugc components, it verifies if some of them has palette_lock property
     * and add the palette to be downloaded.
     * Finally, if there are not palettes pending, promise.all won't be executed.
     */
    loadPalettes() {
      const promises = [];
      let palettes = [];
      const { pdm } = this.$store.state.utils;
      const { sku } = pdm;
      const default_palettes = this.$store.state.utils.configuration.default_palettes ?
                               this.$store.state.utils.configuration.default_palettes[sku] : null
      const passcode = this.$store.state.preloader.passcode;
      const recipe = this.recipe_v2;

      palettes = default_palettes ? palettes.concat(default_palettes) : [];

      if (passcode.paletteId && passcode.paletteId.length > 0) {
        palettes.push(...passcode.paletteId);
      }

      const recipePalette = recipe.palettes;
      if (recipePalette) {
        palettes = palettes.concat(recipePalette);
      }
      const palettesIdSaved = this.$store.state.swatches.palettesId;
      let newPalettesId = palettes.filter((item) => !palettesIdSaved.includes(item));
      newPalettesId = [... new Set(newPalettesId)];
      this.$store.commit("swatches/SET_PALETTES_ID", newPalettesId);
      const finalPalettes = [ ...newPalettesId, ... palettesIdSaved ];
      const UGCEnabledComponents = this.isApparel ?
      this.$store.getters['ugc/getApparelUGCEnabledComponents'] :
      this.$store.getters['ugc/getUGCEnabledComponents'];
      UGCEnabledComponents.forEach(name => { // Add locked palettes if does not exist in finalPalettes
        const lockedPalette = recipe?.components?.[name] && recipe?.components?.[name]?.palette_lock;
        if (!!lockedPalette) {
          this.$store.commit("ugc/SET_UGC_BLOCKED_PALETTES", { component: name, palette: lockedPalette });

          if (!finalPalettes.includes(lockedPalette)) {
            newPalettesId.push(lockedPalette);
          }
        }
      });
      if (newPalettesId.length) {
        newPalettesId.forEach(palette => {
          promises.push(
            this.$store.dispatch("swatches/GET_PALETTES", palette)
            .catch(err => console.error('Palette error: ', err))
          );
        });
        Promise.all(promises).then(() => {
          this.getSwatchesPalettes();
          this.getTabsAvailable();
        });
      } else {
        this.getSwatchesPalettes();
        this.getTabsAvailable();
      }
    },
    getSwatchesPalettes() {
      let palettesTabs = {};
      this.getPalettes.forEach(palette => {
        this.addPaletteToSwatchesTabs(palette, palettesTabs);
      });
      this.$store.commit("swatches/SET_PALETTES_BY_COMPONENT", {
        component: this.activeComponent,
        palettes: palettesTabs
      });
      this.$nextTick(() => this.$eventBus.$emit("tabsDataAndPalettesLoaded"));
    },
    addPaletteToSwatchesTabs(palette, palettesTabs) {
      if (palette.swatches) {
        const { tab_id: tabId } = palette;
        const paletteId = palette.palette_id.toString();
        const swatchesObjs = this.getSwatchesObj(tabId, palette.swatches);

        if (!palettesTabs[tabId]) {
          palettesTabs[tabId] = {};
        }
        palettesTabs[tabId][paletteId] = {};

        if (!palette.hide_palette) {
          palettesTabs[tabId][paletteId].swatches = swatchesObjs;
        }
      }
    },
    getSwatchData(swatchId) {
      const swatch = this.$store.getters['swatches/returnSwatchObj']({ swatchId });

      return {
        groupName: swatch ?
          this.$store.getters['swatches/returnSwatchGroupName']({ swatch }) : null,
        subgroupName: swatch?
          this.$store.getters['swatches/returnSwatchSubgroupName']({ swatch }) : null,
        swatchFound: swatch,
      };
    },
    getSwatchesBySubgroup(component, groupName, subgroupName) {
      const subgroupNameApparel = subgroupName.replace('-apparel', '');
      const swatchsByGroup = this.swatchesByComponent?.[component]?.[groupName];

      return swatchsByGroup?.[subgroupName] ?? swatchsByGroup?.[subgroupNameApparel];
    },
    getSwatchesObj(paletteTabId, swatchesArray) {
      return this.isApparel ?
        this.getSwatchesObjApparel(paletteTabId, swatchesArray) :
        this.getSwatchesObjFootwear(swatchesArray);
    },
    getSwatchesObjApparel(paletteTabId, swatchesArray) {
      const isActiveComponentSub = String(this.activeComponent).search('/') !== -1;
      const isTabComponent = !!(this.recipe_v2.components[paletteTabId] ||
        this.swatchesByComponent[paletteTabId]);
      const swatchesObjs = [];
      let activeComponent = isActiveComponentSub ? 'sub_component' :
        (isTabComponent ? paletteTabId : this.activeComponent);

      swatchesArray.forEach((id) => {
        const { groupName, subgroupName, swatchFound } = this.getSwatchData(id);

        if (swatchFound) {
          /** Add swatches into the group swatchbyComponent when the group and subgroup exist only into the group component */
          if (isActiveComponentSub) {
            const component = isTabComponent ? paletteTabId : this.activeComponent.split('/')[0];
            const existparent = !!this.getSwatchesBySubgroup(component, groupName, subgroupName);

            activeComponent = existparent ? component : 'sub_component';
          }

          const availableSwatchesBySubgroup =
            this.getSwatchesBySubgroup(activeComponent, groupName, subgroupName);

          if (availableSwatchesBySubgroup) {
            availableSwatchesBySubgroup.forEach((swatchId) => {
              if (swatchFound.id === swatchId) {
                swatchesObjs.push(swatchFound);
              }
            });
          }
        }
      });

      return swatchesObjs;
    },
    getSwatchesObjFootwear(swatchesArray) {
      const activeComponent = this.activeComponent;
      const swatchesObjs = [];

      swatchesArray.forEach((id) => {
        const { groupName, subgroupName, swatchFound } = this.getSwatchData(id);

        if (swatchFound) {
          const availableSwatchesBySubgroup =
            this.getSwatchesBySubgroup(activeComponent, groupName, subgroupName);

          if (availableSwatchesBySubgroup) {
            availableSwatchesBySubgroup.forEach((swatchId) => {
              if (swatchFound.id === swatchId) {
                swatchesObjs.push(swatchFound);
              }
            });
          }
        }
      });

      return swatchesObjs;
    },
    getTabsAvailable() {
      let tabsAvailable = this.$store.state.swatches.availableTabs;
      this.getPalettes.forEach(palette => {
        if(!palette.hide_palette) {
          tabsAvailable = this.addAvailableTabs(tabsAvailable, palette.tab_id);
        }
      });
      this.$store.commit("swatches/SET_AVAILABLE_TABS", tabsAvailable);
    },
    addAvailableTabs(tabs, group) {
      if (!tabs.includes(group)) {
        tabs.push(group);
      }
      return tabs;
    },
    handleStripParameters() {
      if (this.getPalettes.find(item => item.strip_params === 1)) {
        stripURLParams(this.$store.state.swatches.paletteStripParams);
      }
    }
  },
  mounted() {
    this.$eventBus.$on("tabsDataRendered", this.loadPalettes);
    this.$eventBus.$on("loadSwatches", this.getSwatchesPalettes);
    this.$eventBus.$on("preloader-finished-loading", this.handleStripParameters);
  },
  beforeDestroy() {
    this.$eventBus.$off("tabsDataRendered", this.loadPalettes);
    this.$eventBus.$off("loadSwatches", this.getSwatchesPalettes);
    this.$eventBus.$off("preloader-finished-loading", this.handleStripParameters);
  },
  render() {
    return null;
  }
};
</script>
